export default "__VITE_ASSET__CJvLLn0B__"